import { readable, writable } from 'svelte/store';
import Papa from 'papaparse';
	
	//data
	//stato
	//codice_regione
	//denominazione_regione
	//codice_provincia
	//denominazione_provincia
	//sigla_provincia
	//lat
	//long
	//totale_casi

		
export const dataProvince = readable(Array.from([]), function start(set) {
	console.log("[dataProvince.store][start]");
		Papa.parse("https://raw.githubusercontent.com/pcm-dpc/COVID-19/master/dati-province/dpc-covid19-ita-province.csv", {
				download: true,
				header: true,
				skipEmptyLines: true,
				complete: function(results) {
					console.log("data parsed : ", results)
					set(Array.from(results.data));
				}
		});	

		return function stop() {
			console.log("[dataProvince.store][stop]");
		};
});

export const regioneSelezionata = writable("Toscana");